<template>
  <div class="pointDetail">
    <div class="header">
      <div class="header-box">
        <span class="text">总爪点</span>
        <span class="point">{{ score }}</span>
      </div>
    </div>
    <div style="height: 120px"></div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        v-if="listData.length > 0"
      >
        <!-- 列表 -->
        <div class="pointList">
          <div v-for="item in listData" :key="item.id">
            <div class="item">
              <div class="left">
                <div class="title">
                  <span>{{ item.comments }}</span>
                </div>
                <div class="time">
                  <span>{{ item.createTime }}</span>
                </div>
              </div>
              <div class="right">
                <span :class="item.score > 0 ? 'add' : 'del'"
                  >{{ item.score > 0 ? '+' : '' }}
                  <span class="num">{{ item.score }}</span>
                </span>
              </div>
            </div>
            <div class="bottom">
              <div class="bottom-div"></div>
            </div>
          </div>
        </div>
      </van-list>
      <van-empty v-else description="暂无数据" />
    </van-pull-refresh>
  </div>
</template>

<script>
import { getQueryScoreLog, getUserInfo } from '@/service/api'
import { Toast } from 'vant'

export default {
  data() {
    return {
      listData: [],
      loading: false,
      finished: false,
      refreshing: false,
      currentPage: 1,
      pageSize: 10,
      score: 0,
    }
  },

  created() {
    this.getUserInfo()
    this.toQueryScoreLog()
  },

  methods: {
    async getUserInfo() {
      try {
        const res = await getUserInfo()
        if (res) {
          this.score = res.score
        }
      } catch (error) {
        Toast(error)
      }
    },
    async toQueryScoreLog() {
      this.loading = true
      try {
        // 下拉刷新
        if (this.refreshing) {
          this.listData = []
          this.refreshing = false
        }
        const data = {
          currentPage: this.currentPage,
          pageSize: this.pageSize,
        }
        const res = await getQueryScoreLog(data)
        if (res) {
          console.log(res)
          this.listData = [...this.listData, ...res.list]
          // this.listData = []
        }
        // 数据全部加载完成
        if (this.listData.length >= res.total) {
          console.log('全部数据')
          this.loading = true
          this.finished = true
          return
        }
        // 加载状态结束
        this.currentPage = ++this.currentPage
        this.loading = false
      } catch (error) {
        Toast(error)
      }
    },

    /* 下拉刷新 */
    onRefresh() {
      this.finished = false
      this.loading = true
      // ----
      this.currentPage = 1
      this.listData = []
      this.toQueryScoreLog()
    },
    // 上拉加载
    onLoad() {
      this.toQueryScoreLog()
    },
  },
}
</script>

<style lang="less" scoped>
.pointDetail {
  /deep/ .van-pull-refresh {
    padding-bottom: 80px;
  }
  // .pointDetail {
  //   padding-top: 20px;
  // }
  .bottom {
    position: relative;
    font-size: 16px;
  }
  .bottom .bottom-div:before {
    content: ' ';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    border-top: 1px solid #ddd;
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }

  .header {
    padding-top: 20px;
    width: 100%;
    height: 120px;
    display: flex;
    justify-content: center;
    position: fixed;
    background-color: #fff;
    z-index: 9;

    .header-box {
      width: 90%;
      height: 100%;
      background-color: #ffe4c8;
      background-image: linear-gradient(to right, #fcecdb, #ffe4c8);
      border-radius: 15px 15px 0 0;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1;
      .text {
        color: #515151;
        font-size: 17px;
        display: inline-block;
        margin-right: 15px;
      }
      .point {
        color: #f17c25;
        font-size: 28px;
        font-family: 'DIN_Alternate';
      }
    }
  }
  .line {
    width: 100%;
    height: 4px;
    background-color: #efefef;
    position: fixed;
    top: 96px;
  }
  .pointList {
    width: 100%;
    padding: 0 5%;
    padding-top: 10px;

    .item {
      // height: 70px;
      padding: 12px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 5px;

      .left {
        font-size: 15px;
        color: #515151;
        .time {
          font-size: 14px;
          color: #9e9e9e;
          display: inline-block;
          margin-top: 4px;
        }
      }
      .right {
        font-size: 19px;
        padding-left: 15px;

        .add {
          // width: 10px;
          color: #6dd400;
          white-space: nowrap;
        }
        .del {
          // width: 10px;
          color: #e02020;
          white-space: nowrap;
        }
        .num {
          font-family: 'DIN_Alternate';
          margin-left: -2px;
        }
      }
    }
  }
}
</style>
